/* eslint-disable no-unused-vars, no-undef */

// import Swiper bundle with all modules installed
import Swiper from 'swiper/swiper-bundle';

// import Sweet Alert
import Swal from 'sweetalert2';

export default {
  init() {
    // JavaScript to be fired on all pages
    // init Swiper:
    // var swiper = new Swiper('.mySwiper', {
    //   navigation: {
    //     nextEl: '.swiper-button-next',
    //     prevEl: '.swiper-button-prev',
    //   },
    // });

    // Submit Newsletter Subscription
    function submitSubscriptionForm() {
      var data = $('#subscribe-form').serialize();
  
      $.ajax({
        url : 'https://sheetdb.io/api/v1/4nd2sj6g6kjt0',
        data : data, // form data
        dataType : 'json', // this data type allows us to receive objects from the server
        type : 'POST',
        beforeSend : function(xhr){
          $('#subscribe-form').attr('disabled');
          $('#subscribe-form :input[type="submit"]').prop('disabled', true);
        },
        success : function( data ){
          $('#subscribe-form :input[type="submit"]').prop('disabled', false);
          $('#subscribe-notice').addClass('hidden');
          $('#success-alert').removeClass('hidden');
          setTimeout(function() {
            $('#subscribe-form :input[name="email"]').val('');
            $('#success-alert').addClass('hidden');
            $('#subscribe-notice').removeClass('hidden');
          }, 3000);
        },
     });
    }

    // Alert Newsletter Privacy Policy
    function showPrivacyPolicyAlert() {
      Swal.fire({
        title: 'At Plastics Europe we take privacy seriously',
        html: 'We collect your email address to send you our newsletter, and we do so on the basis of your consent. To know more on the way we process your personal data, take a look at our <a href="https://legacy.plasticseurope.org/download_file/4384/0" target="_blank" style="font-weight:600;">Privacy Notice</a>. You can withdraw your consent at any time by clicking on the unsubscribe link at the bottom of our newsletter emails. If you have any questions about how we process your personal data, please contact us at <a href="mailto:privacy@plasticseurope.org" style="font-weight:600;">privacy@plasticseurope.org</a>',
        confirmButtonText: langvars.messagekey,
        buttonsStyling: false,
      }).then((result) => {  
          if (result.isConfirmed) {
            submitSubscriptionForm();
          }
      });
    }

    $('#subscribe-form').validate({
      rules: {
        shortdescription: 'required',
        sourceurl: 'required',
      },
      messages: {
          shortdescription: 'Enter a short description. ',
          sourceurl: 'Enter a Source URL. ',
      },
      errorElement: 'span',
      wrapper: 'div',
      errorLabelContainer: '.message',
      submitHandler: function(form) {
        showPrivacyPolicyAlert();
      },
     });

    // Region Switcher
    $('.region-switcher').on('change', function() {
      var region = $(this).val();
      console.log(region);
      window.location.pathname = ('/' + region);
      console.log(window.location);
    })

    $( '.menu-item.has-submenu' ).each(function() {
      $( this ).on( 'mouseenter', function() {
        $(this).find('.submenu').addClass('is-open');
        $(this).find('.submenu .content').removeClass('hidden');
      } );
      $( this ).on( 'mouseleave', function() {
        $(this).find('.submenu').removeClass('is-open');
        $(this).find('.submenu .content').addClass('hidden');
      } );
    });

    // Mobile menu toggle
    $('.menu-toggle').on('touchstart click', function(e) {
      const target = $(this).data('target');
      console.log(target);
      $(target).toggleClass('hidden');
      $(this).find('svg').toggleClass('block');
      $(this).find('svg').toggleClass('hidden');
      e.preventDefault();
    });

    // Mobile menu levels
    $('.open-submenu').on('touchstart click', function(e) {
      const target = $(this).data('target');
      console.log(target);
      $(target).addClass('open');
      e.preventDefault();
    });

    $('.close-submenu').on('touchstart click', function(e) {
      const target = $(this).data('target');
      console.log(target);
      $(target).removeClass('open');
      e.preventDefault();
    });

    // Search
    // Disable enter on Search
    function disableEnterKey(e) {
      var keyCode = e.keyCode || e.which;
      if (keyCode === 13) {
        e.preventDefault();
        return false;
      }
    }

    function showCloseIcon(elem) {
      if ($(elem).parent().find('.close-icon').hasClass('hidden')) {
        $(elem).parent().find('.close-icon').removeClass('hidden');
        $(elem).parent().find('.search-icon').addClass('hidden');
      }
    }

    function showSearchIcon(elem) {
      if ($(elem).find('.search-icon').hasClass('hidden')) {
        $(elem).find('.search-icon').removeClass('hidden');
        $(elem).find('.close-icon').addClass('hidden');
      }
    }

    function openSearchModal(){
      $('#searchModal').removeClass('hidden');
      $('body').addClass('overflow-hidden');
      $('#searchModal').addClass('block');
      $('#searchModal .search-input').val('');
      $('#searchModal .search-input').focus();
    }

    function closeSearchModal(){
      $('#searchModal .search-input').val('');
      $('#searchModal').addClass('hidden');
      $('body').removeClass('overflow-hidden');
      $('#searchModal').removeClass('block');
      $('#search-modal .search-input').val('');
      // clear search field
      if ($('#searchModal .search-icon').hasClass('hidden')) {
        $('#searchModal .search-icon').removeClass('hidden');
        $('#searchModal .close-icon').addClass('hidden');
      }
    }

    $('.search-form .close-icon').on('click', function () {
      let elem = $(this).parent();
      $(this).parent().find('.search-input').val('');
      showSearchIcon(elem);
    })

    function changeSearchCat(){
      // clear search field
      $('#search-field').val('');
      let type = $('#resource-type').val();
      $('#term-id').val(type);
    }

    $('.search-input').on('keypress', function(e) {
      let elem = $(this);
      disableEnterKey(e);
      showCloseIcon(elem);
    });

    $('#open-search').on('click', function () {
      openSearchModal();
    })

    $('.modalOverlay').on('click', function () {
      closeSearchModal();
    })

    $('#resource-type').on('change', function () {
      changeSearchCat();
    })

    var swiper = new Swiper('.mySwiper', {
      autoHeight: true,
      grabCursor: true,
      // effect: 'creative',
      // creativeEffect: {
      //   prev: {
      //     shadow: true,
      //     translate: [0, 0, -400],
      //   },
      //   next: {
      //     translate: ['100%', 0, 0],
      //   },
      // },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
    });

    var groupSwiper = new Swiper('.groupSwiper', {
      // slidesPerView: 2,
      // spaceBetween: 30,
      // slidesPerGroup: 2,
      // loop: true,
      // loopFillGroupWithBlank: true,
      pagination: {
        el: '.swiper-pagination',
        clickable: true,
      },
      navigation: {
        nextEl: '.swiper-arrow-next',
        prevEl: '.swiper-arrow-prev',
      },
      breakpoints: {
        1024: {
          slidesPerView: 2,
          spaceBetween: 30,
          slidesPerGroup: 2,
        },
      },
    });

    // Suggested block hover
    $('.suggested-posts .grid-item').on('mouseenter', function() {
      let bgColor = $(this).find('.overlay').data('overlay');

      $(this).find('.overlay').removeClass(bgColor);
      $(this).find('.overlay').removeClass('translate-y-1/2 opacity-80');
      $(this).find('.overlay').addClass('translate-y-0 opacity-100 bg-mist-900');

      $(this).find('.details').removeClass('translate-y-1/2 text-white');
      $(this).find('.details').addClass('translate-y-0');

      $(this).find('.details > div').removeClass('h-1/2');
      $(this).find('.details > div').addClass('h-full');

      $(this).find('.details .excerpt').removeClass('hidden opacity-0');
      $(this).find('.details .excerpt').addClass('line-clamp-4 opacity-100');
    });

    $('.suggested-posts .grid-item').on('mouseleave', function() {
      let bgColor = $(this).find('.overlay').data('overlay');

      $(this).find('.overlay').removeClass('translate-y-0 opacity-100 bg-mist-900');
      $(this).find('.overlay').addClass(bgColor);
      $(this).find('.overlay').addClass('translate-y-1/2 opacity-80');

      $(this).find('.details').removeClass('translate-y-0');
      $(this).find('.details').addClass('translate-y-1/2 text-white');

      $(this).find('.details > div').removeClass('h-full');
      $(this).find('.details > div').addClass('h-1/2');

      $(this).find('.details .excerpt').removeClass('line-clamp-4 opacity-100');
      $(this).find('.details .excerpt').addClass('hidden opacity-0');
    });
    
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js